import {
  SET_STOP_RESUME_POSITION,
  CLEAR_STOP_RESUME_POSITION,
  STOP_RESUME_START_FROM_BEGINNING,
  STOP_RESUME_START_FROM_SR_POSITION,
} from '../../constants'

export default function StopResumeReducer(
  state = {},
  {
    type,
    path,
    position,
    id,
  } = {}
) {
  switch (type) {
    case SET_STOP_RESUME_POSITION: {
      const entry = state[path]

      return {
        ...state,
        [path]: {
          ...entry,
          stopResumePosition: position,
        },
      }
    }

    case CLEAR_STOP_RESUME_POSITION: {
      const newState = { ...state }
      if (newState[path]) {
        delete newState[path].stopResumePosition
        delete newState[path].resumeModalAccepted
      }
      return newState
    }

    case STOP_RESUME_START_FROM_BEGINNING: {
      const entry = state[path]

      return {
        ...state,
        [path]: {
          ...entry,
          stopResumePosition: 0,
          resumeModalAccepted: true,
        },
      }
    }

    case STOP_RESUME_START_FROM_SR_POSITION: {
      const entry = state[path]

      return {
        ...state,
        [path]: {
          ...entry,
          resumeModalAccepted: true,
        },
      }
    }

    default:
      return state
  }
}
